const initialState = {
  monthlyPlanning: {},
  loading: true
};

export function fetchMonthlyPlanning(state = initialState, action) {
  switch (action.type) {
    case 'FETCH_MONTHLY_PLANNING.SUCCESS':
      return {
        ...state,
        monthlyPlanning: action.monthlyPlanning.body
      };
    case 'SAVE_MONTHLY_PLANNING.SUCCESS':
      return {
        ...state,
        monthlyPlanning: action.monthlyPlanning.body,
      };
    default:
      return state
  }
}
